export function buscaEnArray(valorBuscar, campos, valores) {
  const needle = valorBuscar == null ? '' : String(valorBuscar)
  if (!needle) return ''

  const listaCampos = Array.isArray(campos)
    ? campos
    : campos != null && typeof campos === 'object'
      ? Object.values(campos)
      : [campos]

  const listaValores = Array.isArray(valores)
    ? valores
    : valores != null && typeof valores === 'object'
      ? Object.values(valores)
      : [valores]

  const idx = listaCampos.findIndex((v) => v != null && String(v) === needle)
  if (idx === -1) return ''

  const out = listaValores[idx]
  return out == null ? '' : String(out)
}
